import { HURRICANE_METRICS } from '../../../../../mockData/HurricaneMetrics.js';
import { PerilMetrics } from '../../../../shared/PerilMetrics.jsx';

export function HurricaneMetrics() {
  return <PerilMetrics data={HURRICANE_METRICS} />;
}
